<h1 class="font-medium text-3xl ~mb-4/8">{{ data().name }}</h1>
@defer {
    <div
        class="gap-2 grid grid-cols-4 grid-rows-4 lg:grid-rows-2 mb-8 max-h-96"
        gallerize="booking-gallery"
    >
        @if (data().gallery && data().gallery.images) {
            <!-- TODO change once we have the correct image -->
            <img
                [src]="data().gallery.images[0].url"
                class="col-span-4 lg:col-span-2 row-span-3 lg:row-span-2 rounded-t-2xl lg:rounded-l-2xl lg:rounded-tr-none size-full object-cover"
                [attr.imageSrc]="data().gallery.images[0].url"
                [attr.thumbSrc]="
                    domhandler.getSmallestImageAsWebp(data().gallery.images[0])
                "
                [alt]="
                    data().gallery.images[0].alternativeText ||
                    'Apartment image'
                "
            />
            <img
                [src]="data().gallery.images[1].url"
                class="col-span-1 row-span-1 rounded-bl-2xl lg:rounded-bl-none size-full object-cover"
                [attr.imageSrc]="data().gallery.images[1].url"
                [attr.thumbSrc]="
                    domhandler.getSmallestImageAsWebp(data().gallery.images[1])
                "
                [alt]="
                    data().gallery.images[1].alternativeText ||
                    'Apartment image'
                "
            />
            <img
                [src]="data().gallery.images[2].url"
                class="col-span-1 row-span-1 lg:rounded-tr-2xl size-full object-cover"
                [attr.imageSrc]="data().gallery.images[2].url"
                [attr.thumbSrc]="
                    domhandler.getSmallestImageAsWebp(data().gallery.images[2])
                "
                [alt]="
                    data().gallery.images[2].alternativeText ||
                    'Apartment image'
                "
            />
            <img
                [src]="data().gallery.images[3].url"
                class="col-span-1 row-span-1 size-full object-cover"
                [attr.imageSrc]="data().gallery.images[3].url"
                [attr.thumbSrc]="
                    domhandler.getSmallestImageAsWebp(data().gallery.images[3])
                "
                [alt]="
                    data().gallery.images[3].alternativeText ||
                    'Apartment image'
                "
            />
            <img
                [src]="data().gallery.images[4].url"
                class="col-span-1 row-span-1 rounded-br-2xl size-full object-cover"
                [attr.imageSrc]="data().gallery.images[4].url"
                [attr.thumbSrc]="
                    domhandler.getSmallestImageAsWebp(data().gallery.images[4])
                "
                [alt]="
                    data().gallery.images[4].alternativeText ||
                    'Apartment image'
                "
            />
        }
    </div>
}

<div class="flex md:flex-row flex-col-reverse ~gap-0/16">
    <div class="h-fit">
        <app-rich-text [data]="data().description"></app-rich-text>
        @if (data().map) {
            <app-map [data]="data().map" class="block my-8 p-0"></app-map>
        }
        @switch (bookingService.formState()) {
            @case (bookingService.formStateEnum.Success) {
                <h1
                    class="font-semibold text-green-500 text-center ~mt-8/24 ~text-xl/2xl"
                >
                    {{ data().statusText.successText }}
                </h1>
            }
            @case (bookingService.formStateEnum.Error) {
                <h1
                    class="font-semibold text-red-500 text-center ~mt-8/24 ~text-xl/2xl"
                >
                    {{ data().statusText.failureText }}
                </h1>
                @if (bookingService.errorMessage()) {
                    <p class="mt-4 text-center">
                        {{ bookingService.errorMessage() }}
                    </p>
                }
                <app-button
                    class="block justify-self-center mt-4"
                    (click)="
                        bookingService.formState.set(
                            bookingService.formStateEnum.Idle
                        );
                        bookingService.errorMessage.set(undefined)
                    "
                >
                    {{ "booking.retry" | translate }}
                </app-button>
            }
            @default {
                <app-booking-full-form></app-booking-full-form>
            }
        }
    </div>
    @if (
        bookingService.config.hasValue() &&
        (bookingService.formState() === bookingService.formStateEnum.Idle ||
            bookingService.formState() ===
                bookingService.formStateEnum.Submitting ||
            bookingService.formState() === bookingService.formStateEnum.Invalid)
    ) {
        <app-booking-form class="w-full md:w-auto"></app-booking-form>
    }
</div>
